import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { PING_PLAYBACK_CAMERA } from '../../../constants/service.types';
import { socketEmitEvent } from '../../../redux/actions';

export const usePingPlayback = ({
  serial,
  namespace,
  isPlayingRef,
  playbackStreamRef,
  recordId,
  fromTime,
  toTime,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!serial || !namespace) return;
    const intervalId = setInterval(() => {
      if (!isPlayingRef.current) return;
      const stream = playbackStreamRef.current;
      const dataBody = {
        serial,
        namespace,
        control: null,
        ...(stream?.sessionId ? { sessionId: stream.sessionId } : {}),
        ...(stream?.shareSessionId ? { shareSessionId: stream.shareSessionId } : {}),
        ...(stream?.supportGateways ? { supportGateways: stream.supportGateways } : {}),
        ...(recordId ? { recordId } : {}),
        ...(fromTime ? { fromTime, from: fromTime } : {}),
        ...(toTime ? { toTime, to: toTime } : {}),
      };
      dispatch(
        socketEmitEvent({
          appServiceType: PING_PLAYBACK_CAMERA,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        }),
      );
    }, 10000);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serial, namespace, recordId, fromTime, toTime]);
};
